export enum TransitionQuizResults {
  CHOICE = 'c9793825-cbd7-4cf2-ba06-ec9acc102a23',
  GOOD_AT = '252abf0a-8953-4145-ab7d-402668054372',
  INSPIRATION = '653ba6d2-9d7f-4721-a71f-ad8c5cdadab5',
  HAPPY = '30ac711b-5b43-47e5-b366-a3e1d38cdbf1',
  RESOURCES = '1af94bd4-a38c-4a56-aa6e-636bc13b8589',
}
